module.exports = require("!!vue-loader!./../../node_modules/vue-markdown-loader/_cache/switch-3.vue");


//////////////////
// WEBPACK FOOTER
// ./docs/examples/switch.md
// module id = 227
// module chunks = 0